import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Divider, Paper, Typography } from '@material-ui/core'

import {
  TicketFeedback,
  TicketMessages,
  ReplyTicket,
  ReopenTicket,
} from './components'
import { Container, ContentHeader, LoadingFeedback, Page } from 'components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'

import useStyles from './styles'

const TicketDetails = ({ match }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)

  const { ticketId } = match.params

  const { response, refresh, isLoading } = useFetch(
    service.dponet.tickets.get,
    {
      ticketId: ticketId,
    },
  )

  const {
    response: messagesResponse,
    refresh: messageRefresh,
    isLoading: isLoadingMessage,
  } = useFetch(service.dponet.tickets.showMessages, { ticketId: ticketId })

  const ticket = useMemo(() => response?.data?.ticket, [response])
  const ticketMessages = useMemo(
    () => messagesResponse?.data?.ticketMessages,
    [messagesResponse],
  )

  const statusKind = ticket?.status?.kind
  const isTicketClosed = ['completed', 'cancelled'].includes(statusKind)

  const shouldPermitReply = !isTicketClosed && ticket?.allowedRespond

  const shouldPermitReopen =
    statusKind === 'completed' && ticket?.permissionReopen

  return (
    <Page title="Detalhes Parecer Técnico">
      <LoadingFeedback open={isLoading || loading} />
      <Container maxWidth={false}>
        <ContentHeader title={`Solicitação ID: ${ticketId}`} />
        <Paper component={Box} elevation={2} mb={4} p={3} display="flex">
          <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" mb={2}>
              <Typography className={classes.boxId}>{ticket?.id}</Typography>
              <Typography
                className={classes.boxStatus}
                style={{
                  backgroundColor: ticket?.status?.color,
                  color: ticket?.status?.textColor,
                }}
              >
                {ticket?.status?.name}
              </Typography>
            </Box>
            <Typography variant="h5">Categoria: {ticket?.title}</Typography>
            <Typography variant="h6">
              Título: {ticket?.subtitle ?? 'Não informado'}
            </Typography>
            <Divider />

            <TicketMessages
              ticketMessages={ticketMessages}
              isLoadingMessage={isLoadingMessage}
            />

            {shouldPermitReply && (
              <ReplyTicket
                refresh={messageRefresh}
                setLoading={setLoading}
                ticketId={ticketId}
              />
            )}

            {shouldPermitReopen && (
              <ReopenTicket ticketId={ticketId} refresh={refresh} />
            )}
          </Box>
        </Paper>

        {isTicketClosed &&
          ticket?.allowedRespond &&
          ticket?.evaluationEnabled && (
            <TicketFeedback
              ticketId={ticketId}
              ticketFeedback={ticket?.ticketFeedback}
              refresh={refresh}
            />
          )}
      </Container>
    </Page>
  )
}

TicketDetails.propTypes = {
  match: PropTypes.object,
}

export default TicketDetails
